import React from 'react';

const TermsModal: React.FC = () => {
  return (
    <div
      className="modal fade"
      id="termsModal"
      tabIndex={-1}
      aria-labelledby="termsModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content shadow-lg border-0">
          <div className="modal-header bg-body-tertiary py-3 border-body">
            <h5
              className="modal-title fw-bold text-body-emphasis"
              id="termsModalLabel"
            >
              Termini di Servizio
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Chiudi"
            />
          </div>

          <div
            className="modal-body p-4 bg-body"
            style={{ maxHeight: '70vh', overflowY: 'auto' }}
          >
            <div className="text-body">
              <p>
                I presenti Termini di Servizio disciplinano l’accesso e
                l’utilizzo del sito, dell’area riservata e dei contenuti
                digitali offerti dal titolare.
              </p>

              <h6 className="fw-bold mt-4">1. Titolare del sito</h6>
              <p className="mb-0">
                Il sito è gestito da <strong>Annalisa Picca</strong>, con sede
                in <strong>Via Simone Stratico n. 18 20148 Milano</strong>,
                contattabile ai recapiti indicati nel sito.
              </p>

              <h6 className="fw-bold mt-4">2. Oggetto del servizio</h6>
              <p>
                Il sito offre contenuti informativi, risorse gratuite e
                contenuti digitali a pagamento, inclusi videocorsi fruibili
                esclusivamente online tramite area riservata e in modalità
                streaming.
              </p>
              <p>
                Salvo ove diversamente indicato, i contenuti acquistati non sono
                scaricabili e restano accessibili secondo le modalità previste
                dal sito e dall’account utente.
              </p>

              <h6 className="fw-bold mt-4">3. Registrazione e account</h6>
              <p>
                Per accedere ad alcune risorse gratuite o a contenuti acquistati
                può essere richiesta la registrazione di un account personale.
              </p>
              <p>
                L’utente è responsabile della correttezza dei dati forniti,
                della riservatezza delle proprie credenziali e di tutte le
                attività svolte tramite il proprio account.
              </p>
              <p>
                L’account è personale e non può essere ceduto, condiviso o
                utilizzato da terzi senza autorizzazione.
              </p>

              <h6 className="fw-bold mt-4">4. Acquisti e pagamenti</h6>
              <p>
                Gli acquisti effettuati sul sito sono regolati anche dalle
                condizioni dei fornitori di pagamento utilizzati, tra cui
                Stripe, PayPal e Satispay.
              </p>
              <p>
                L’accesso ai contenuti acquistati viene attivato secondo le
                modalità tecniche previste dal sito, una volta completata con
                successo la procedura di pagamento.
              </p>

              <h6 className="fw-bold mt-4">5. Fruizione dei videocorsi</h6>
              <p>
                I videocorsi acquistati sono destinati esclusivamente
                all’utilizzo personale dell’utente autorizzato e sono fruibili
                in streaming attraverso la piattaforma, ove previsto dal sito.
              </p>
              <p>
                Non è consentito scaricare, registrare, duplicare, distribuire,
                proiettare pubblicamente, cedere, sublicenziare, condividere o
                mettere a disposizione di terzi i videocorsi o le credenziali di
                accesso, salvo espressa autorizzazione scritta del titolare.
              </p>

              <h6 className="fw-bold mt-4">
                6. Contenuti gratuiti scaricabili
              </h6>
              <p>
                Eventuali contenuti gratuiti scaricabili, inclusi video, audio,
                PDF o altri materiali digitali, sono concessi per uso personale,
                informativo o formativo, salvo diversa indicazione espressa.
              </p>
              <p>
                Tali contenuti non possono essere rivenduti, redistribuiti,
                pubblicati nuovamente, concessi a terzi o utilizzati a fini
                commerciali senza il preventivo consenso scritto del titolare.
              </p>

              <h6 className="fw-bold mt-4">7. Proprietà intellettuale</h6>
              <p>
                Tutti i contenuti presenti sul sito, inclusi testi, marchi,
                elementi grafici, immagini, video, audio, documenti, materiali
                didattici, corsi e contenuti scaricabili, sono protetti dalla
                normativa applicabile in materia di proprietà intellettuale e
                appartengono al titolare o ai rispettivi aventi diritto.
              </p>
              <p>Ogni utilizzo non autorizzato è vietato.</p>

              <h6 className="fw-bold mt-4">8. Uso consentito del sito</h6>
              <p>
                L’utente si impegna a utilizzare il sito in modo lecito e
                corretto.
              </p>
              <ul>
                <li>
                  tentare di aggirare sistemi di protezione o limitazioni
                  tecniche;
                </li>
                <li>
                  accedere senza autorizzazione ad aree o contenuti riservati;
                </li>
                <li>condividere account o credenziali con altri soggetti;</li>
                <li>
                  riprodurre o sfruttare economicamente i contenuti senza
                  autorizzazione;
                </li>
                <li>
                  utilizzare il sito in modo da comprometterne sicurezza,
                  integrità o disponibilità.
                </li>
              </ul>

              <h6 className="fw-bold mt-4">
                9. Sospensione o limitazione dell’accesso
              </h6>
              <p>
                Il titolare si riserva il diritto di sospendere, limitare o
                revocare l’accesso al sito o all’area riservata in caso di
                violazione dei presenti termini, uso improprio del servizio,
                mancato pagamento, esigenze tecniche o ragioni di sicurezza.
              </p>

              <h6 className="fw-bold mt-4">10. Esclusione di garanzie</h6>
              <p>
                Il sito e i contenuti sono forniti secondo disponibilità. Il
                titolare adotta misure ragionevoli per garantire continuità,
                accuratezza e aggiornamento, ma non garantisce l’assenza di
                interruzioni, errori tecnici o incompatibilità temporanee.
              </p>

              <h6 className="fw-bold mt-4">
                11. Limitazione di responsabilità
              </h6>
              <p>
                Nei limiti consentiti dalla legge, il titolare non potrà essere
                ritenuto responsabile per danni indiretti, perdita di dati,
                interruzioni di servizio, malfunzionamenti di terze parti o uso
                improprio del sito da parte degli utenti.
              </p>

              <h6 className="fw-bold mt-4">12. Link o servizi di terzi</h6>
              <p>
                Il sito può contenere collegamenti o integrazioni con servizi di
                terzi, inclusi fornitori di pagamento o strumenti di contatto.
                Tali servizi sono disciplinati dai rispettivi termini e dalle
                rispettive informative.
              </p>

              <h6 className="fw-bold mt-4">13. Modifiche ai termini</h6>
              <p>
                Il titolare si riserva il diritto di aggiornare o modificare in
                qualsiasi momento i presenti Termini di Servizio. Le modifiche
                saranno efficaci dalla loro pubblicazione sul sito, salvo
                diversa indicazione.
              </p>

              <h6 className="fw-bold mt-4">
                14. Legge applicabile e foro competente
              </h6>
              <p className="mb-0">
                I presenti Termini di Servizio sono regolati dalla legge
                italiana, salvo eventuali diritti inderogabili previsti dalla
                normativa applicabile a tutela del consumatore.
              </p>
            </div>

            <div className="modal-footer bg-body-tertiary py-3 border-body mt-4">
              <button
                type="button"
                className="btn btn-primary px-4"
                data-bs-dismiss="modal"
              >
                Chiudi
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
